<script setup>
import ConfirmButton from 'dashboard/components-next/button/ConfirmButton.vue';

const emit = defineEmits(['delete']);
</script>

<template>
  <div class="flex items-center justify-between">
    <ConfirmButton
      :label="$t('PROFILE_SETTINGS.FORM.DELETE_ACCOUNT.BTN_LABEL')"
      :confirm-label="$t('PROFILE_SETTINGS.FORM.DELETE_ACCOUNT.CONFIRM_LABEL')"
      :confirm-hint="$t('PROFILE_SETTINGS.FORM.DELETE_ACCOUNT.CONFIRM_HINT')"
      color="ruby"
      confirm-color="ruby"
      icon="i-lucide-trash-2"
      class="rounded-xl"
      @click="emit('delete')"
    />
  </div>
</template>
